export const DELETED_COMPANIES_REQUEST = 'DELETED_COMPANIES_REQUEST';
export const DELETED_COMPANIES_SUCCESS = 'DELETED_COMPANIES_SUCCESS';
export const DELETED_COMPANIES_FAIL = 'DELETED_COMPANIES_FAIL';

export function deletedCompanyRequest(fetch) {
    return {
        type:DELETED_COMPANIES_REQUEST,
        payload: {fetch},
    };
}

export const SINGLE_COMPANIES_REQUEST = 'SINGLE_COMPANIES_REQUEST';
export const SINGLE_COMPANIES_SUCCESS = 'SINGLE_COMPANIES_SUCCESS';
export const SINGLE_COMPANIES_FAIL = 'SINGLE_COMPANIES_FAIL';

export function singleCompanyRequest(id) {
    return {
        type:SINGLE_COMPANIES_REQUEST,
        payload: {id},
    };
}

export const UPDATE_COMPANIES_REQUEST = 'UPDATE_COMPANIES_REQUEST';
export const UPDATE_COMPANIES_SUCCESS = 'UPDATE_COMPANIES_SUCCESS';
export const UPDATE_COMPANIES_FAIL = 'UPDATE_COMPANIES_FAIL';

export function updateCompanyRequest(id,form) {
    return {
        type:UPDATE_COMPANIES_REQUEST,
        payload: {id,form},
    };
}